import React from 'react';
import { FaUsers, FaEye, FaSpinner } from 'react-icons/fa';

interface StatsHeaderProps {
  totalStreamers: number;
  totalViewers: number;
  isLoading?: boolean;
}

const StatsHeader: React.FC<StatsHeaderProps> = ({
  totalStreamers,
  totalViewers,
  isLoading = false
}) => {
  const formatViewerCount = (count: number): string => {
    if (count < 1000) {
      return count.toString();
    }
    
    if (count < 1000000) {
      const k = Math.floor(count / 100) / 10;
      return `${k}k`;
    }
    
    const m = Math.floor(count / 100000) / 10;
    return `${m}M`;
  };

  if (isLoading) {
    return (
      <div className="stats-container fade-in">
        <div className="stat-item">
          <div className="stat-icon">
            <FaSpinner className="spinning" />
          </div>
          <div className="stat-content">
            <span className="stat-number">---</span>
            <span className="stat-label">Streamers en live</span>
          </div>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <div className="stat-icon">
            <FaSpinner className="spinning" />
          </div>
          <div className="stat-content">
            <span className="stat-number">---</span>
            <span className="stat-label">Viewers totaux</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="stats-container fade-in">
      <div className="stat-item">
        <div className="stat-icon">
          <FaUsers />
        </div>
        <div className="stat-content">
          <span className="stat-number">{totalStreamers}</span>
          <span className="stat-label">
            Streamer{totalStreamers !== 1 ? 's' : ''} en live
          </span>
        </div>
      </div>
      <div className="stat-divider"></div>
      <div className="stat-item">
        <div className="stat-icon">
          <FaEye />
        </div>
        <div className="stat-content">
          <span className="stat-number">{formatViewerCount(totalViewers)}</span>
          <span className="stat-label">Viewers totaux</span>
        </div>
      </div>
    </div>
  );
};

export default StatsHeader;